import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=130bd649&scoped=true&lang=true&"
import script from "./Subjects.vue?vue&type=script&lang=js&"
export * from "./Subjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130bd649",
  null
  
)

export default component.exports